<div class="search-container">
  <div class="search-input-wrapper">
    <i class="bi bi-search search-icon"></i>
    <input
      [formControl]="searchControl"
      (focus)="onFocus()"
      type="text"
      placeholder="Global search..."
      autocomplete="off"/>
    <button *ngIf="searchControl.value" class="clear-btn" (click)="onClearClick()">
      <i class="bi bi-x"></i>
    </button>
  </div>

  <div class="results-dropdown" *ngIf="isOpen()">

    <ng-container *ngIf="!selectedCategory(); else resultsView">

      <div class="state-message" *ngIf="isCategoriesLoading()">Searching…</div>

      <div class="state-message" *ngIf="!isCategoriesLoading() && categories().length === 0">
        No matches
      </div>

      <ng-container *ngIf="!isCategoriesLoading() && categories().length > 0">
        <div class="group-header">Categories</div>
        <div class="result-item" *ngFor="let category of categories()" (click)="selectCategory(category)">
          <span class="result-reference">{{ category.displayName }}</span>
          <i class="bi bi-chevron-right result-chevron"></i>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #resultsView>
      <div class="results-header">
        <button class="back-btn" (click)="backToCategories()">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="results-header-title">{{ selectedCategory()!.displayName }}</span>
        <span class="results-header-count" *ngIf="!isResultsLoading()">{{ totalElements() }}</span>
      </div>

      <div class="state-message" *ngIf="isResultsLoading()">Loading…</div>

      <div class="state-message" *ngIf="!isResultsLoading() && results().length === 0">
        No matches
      </div>

      <ng-container *ngIf="!isResultsLoading() && results().length > 0">
        <div class="result-item" *ngFor="let row of results()" (click)="navigate(row)">
          <div class="result-body">
            <span class="result-reference">{{ rowPrimary(row) }}</span>
            <span class="result-sub" *ngIf="rowSecondary(row)">{{ rowSecondary(row) }}</span>
          </div>
        </div>
      </ng-container>

      <div class="results-footer" *ngIf="!isResultsLoading() && totalPages() > 1">
        <button class="pager-btn" (click)="prevPage()" [disabled]="currentPage() === 0">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pager-label">{{ currentPage() + 1 }} / {{ totalPages() }}</span>
        <button class="pager-btn" (click)="nextPage()" [disabled]="currentPage() + 1 >= totalPages()">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </ng-template>
  </div>
</div>
